<script setup>
import {reactive, ref} from "vue";
import {validateNumber} from "../../store/form_validate"
import {useSystem} from "../../store/system"
import {useUser} from "../../store/user"
import VueQrcode from 'vue-qrcode';

const userStore = useUser()
const systemStore = useSystem()

userStore.googleAuthApi()

const submitLoading = ref(false)
// 谷歌验证器表单
const ruleFormRef1 = ref(null)
const ruleForm1 = reactive({
  google_code: '',
  type: '1'
})
const rules1 = reactive({
  google_code: [
    {required: true, type: 'string', message: 'verification Code error!', trigger: 'blur'},
  ],
  type: [
    {required: true, type: 'string', message: 'Invalid type error!', trigger: 'blur'},
  ]
})
const submitForm1 = async (formEl) => {
  if (!formEl) return
  submitLoading.value = true
  await formEl.validate((valid, fields) => {
    if (valid) {
      userStore.verifyGoogleAuthCodeApi(ruleForm1.google_code)
    } else {
      console.log('error submit!', fields)
    }
  })

  setTimeout(() => {
    formEl.resetFields()
    submitLoading.value = false
  }, 500)
}
const resetForm1 = (formEl) => {
  if (!formEl) return
  formEl.resetFields()
}


// 支付 登录密码修改
const ruleFormRef = ref(null)
const ruleForm = reactive({
  new_password: '',
  repeat_password: '',
  google_code: '',
})
const rules = reactive({
  new_password: [
    {required: true, type: 'string', message: 'new password error!', trigger: 'blur'},
  ],
  repeat_password: [
    {required: true, validator: (rule, value, callback) => {
        if (value !== ruleForm.new_password) {
          callback(new Error(rule.message));
        } else {
          callback();
        }
      }, message: 'repeat password error!', trigger: 'blur'},
  ],
  google_code: [
    {required: true, type: 'string', message: 'verification Code error!', trigger: 'blur'},
  ],
})
const submitForm = async (formEl) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      if (currentTab.value === 2) {
        //修改支付密码
        userStore.resetPayPwdApi({
          password: ruleForm.new_password,
          google_code: ruleForm.google_code
        })
      }
      if (currentTab.value === 3) {
        //修改支付密码
        userStore.resetLoginPwdApi({
          password: ruleForm.new_password,
          google_code: ruleForm.google_code
        })
      }
    } else {
      console.log('error submit!', fields)
    }
  })
  formEl.resetFields()
}
const resetForm = (formEl) => {
  if (!formEl) return
  formEl.resetFields()
}

const currentTab = ref(1)
const tabs = [
  {
    label: 'Two factor',
    value: 1,
  },
  {
    label: 'Payment Password change',
    value: 2,
  },
  {
    label: 'Login Password change',
    value: 3,
  },
]
const tabsChange = (val) => {
  // val 1: google验证其   2：支付密码   3：登陆密码
  currentTab.type = val
}

</script>

<template>
  <el-row>
    <el-col :span="24">
      <div class="card-bg">
        <div class="custom-style tw-p-4 tw-bottom-line tw-font-bold tw-text-[18px]">
          <el-segmented
              class="!tw-flex"
              v-model="currentTab"
              :options="tabs"
              size="large"
              @change="tabsChange"
          >
            <template #default="scope">
              <div class="tw-flex tw-justify-start tw-items-center">
                <font-awesome-icon v-if="scope.item.value == 1" class="tw-text-[15px]" :icon="['fas', 'key']" />
                <font-awesome-icon v-if="scope.item.value != 1" class="tw-text-[15px]" :icon="['fas', 'lock']" />
                <div class="tw-ml-1">{{ scope.item.label }}</div>
              </div>
            </template>
          </el-segmented>
        </div>
        <div class="tw-p-4 tw-flex tw-justify-center" v-if="currentTab != 1">
          <el-form
              ref="ruleFormRef"
              style="max-width: 500px"
              :model="ruleForm"
              :rules="rules"
              label-width="auto"
              label-position="top"
              class="tw-w-full"
              size="large"
              status-icon
          >
            <el-form-item>
              <div class="tw-font-bold tw-text-[18px]" v-if="currentTab == 2">Payment Password change</div>
              <div class="tw-font-bold tw-text-[18px]" v-if="currentTab == 3">Login Password change</div>
            </el-form-item>

            <el-form-item label="New Password" prop="new_password">
              <el-input type="password" v-model="ruleForm.new_password" />
            </el-form-item>

            <el-form-item label="Repeat Password" prop="repeat_password">
              <el-input type="password" v-model="ruleForm.repeat_password" />
            </el-form-item>

            <el-form-item label="Google Verification Code" prop="google_code">
              <el-input v-model="ruleForm.google_code" />
            </el-form-item>

            <el-form-item>
              <div class="tw-mt-[1rem] tw-flex tw-justify-end tw-w-full tw-space-x-5">
                <el-button @click="resetForm(ruleFormRef)">Clear</el-button>
                <el-button :loading="submitLoading" type="primary" @click="submitForm(ruleFormRef)">
                  Submit
                </el-button>
              </div>
            </el-form-item>
          </el-form>

        </div>

        <div class="tw-p-4 tw-flex tw-justify-center" v-if="currentTab == 1">
          <el-form
              ref="ruleFormRef1"
              style="max-width: 500px"
              :model="ruleForm1"
              :rules="rules1"
              label-width="auto"
              label-position="top"
              class="tw-w-full"
              size="large"
              status-icon
          >

            <el-form-item class="tw-text-center">
              <div>
                <div class="tw-font-bold tw-text-[18px]">Two factor</div>
                <div class="tw-font-bold tw-py-2">Authenticator apps</div>
                <div>Install google authentication
                  <a class="tw-text-sky-500" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2">(Install here)</a>
                  Or
                  <a class="tw-text-sky-500" href="https://chromewebstore.google.com/detail/authenticator/bhghoamapcdpbohphigoooaddinpkbai?hl=en-US">Authenticator appsChrome Extension</a>
                  Or
                  <a class="tw-text-sky-500" href="https://addons.mozilla.org/en-US/firefox/addon/auth-helper/">Firefox Add-ons</a>
                  <!--              Or Microsoft (Edge)-->
                </div>
                <div class="tw-flex tw-justify-center tw-py-8">
                  <vue-qrcode
                      class="tw-rounded-lg"
                      :color="{ dark: '#000000ff', light: '#ffffffff' }"
                      type="image/jpeg"
                      v-if="userStore.getGoogle2faQrcode"
                      :value="userStore.getGoogle2faQrcode"
                      :scale="5"
                      :margin="2"
                  ></vue-qrcode>
                </div>
                <div class="tw-px-4 tw-py-6 tw-flex tw-justify-start tw-items-center card-white-bg-active">
                  <el-icon size="25"><InfoFilled /></el-icon>
                  <div class="tw-ml-5">
                    <div>If you having trouble using the qr code select manual entry on your app and enter your username and the code</div>
                    <div class="tw-font-bold">{{userStore.getUserInfo.google2fa_secret}}</div>
                  </div>
                </div>
              </div>
            </el-form-item>

            <el-form-item label="Verification Code" prop="google_code">
              <el-input v-model="ruleForm1.google_code" />
            </el-form-item>

            <el-form-item>
              <div class="tw-mt-[1rem] tw-flex tw-justify-end tw-w-full tw-space-x-5">
                <el-button @click="resetForm1(ruleFormRef1)">Clear</el-button>
                <el-button :loading="submitLoading" type="primary" @click="submitForm1(ruleFormRef1)">
                  Submit
                </el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>

      </div>
    </el-col>
  </el-row>
</template>

<style lang="scss">

.custom-style .el-segmented {
  background: $p-bg-white-linear-active-color !important;
  color: $p-text-color !important;
  //--el-segmented-item-selected-bg-color: $p-tabs-hover-bg-color;
  --el-segmented-item-selected-bg-color: rgba(255,255,255, .4);

  .el-segmented__group{
    display: flex !important;
    flex-wrap: wrap !important;

    .el-segmented__item{
      min-height: 50px;

      &:hover{
        background: $p-tabs-hover-bg-color !important;
        color: $p-text-color;
      }

    }
  }
}

@media (max-width: 639px) {
  .el-segmented__item {
    border-bottom: 2px solid $p-border-color;
  }
}

</style>
